const AcknowledgementBody = () => {
  return (
    <section className="flex flex-col  items-center">
      <div className="flex flex-col my-10 gap-5 p-3 md:p-5 lg:p-10 max-w-[80rem] w-full text-[#667085] text-[1.1rem] font-[500]">
        <div className="text-4xl font-[600] mx-auto text-[#34B3EB]">
          Acknowledgement
        </div>
        <div className="">
          These are the terms and conditions governing the use of this service
          and the agreement that operates between You and the Company. These
          terms and conditions set out the rights and obligations of all users
          regarding the use of Service
        </div>
        <div className="">
          Your access to and use of the Service is conditioned on Your
          acceptance and compliance with these terms and conditions.These terms
          and conditions apply to all visitors, users and others who access the
          use of this Service.
        </div>
        <div className="">
          By accessing or using this Service You agree to be bound by these
          Terms and Conditions. If you disagree with any part of these Terms and
          Conditions, please do not use this Service.
        </div>
      </div>
    </section>
  );
};

export default AcknowledgementBody;
